// St. Louis regional dashboards — fetched from /api/regions at runtime
// with a static fallback so the UI never breaks if the API is unreachable.
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const FALLBACK_REGIONS = [
  { value: 'city_wide',    label: 'City-Wide' },
  { value: 'north_city',   label: 'North City Community' },
  { value: 'south_city',   label: 'South City Community' },
  { value: 'north_county', label: 'North County Community' },
];

// Mutable export — components import { REGIONS } and re-render via the
// hydrate event below (fires once at app boot). The shape is stable so a
// re-render isn't strictly required for label changes; new entries do
// require a re-render in components that hold REGIONS in closure.
export let REGIONS = [...FALLBACK_REGIONS];

const labelMap = () => REGIONS.reduce((acc, r) => { acc[r.value] = r.label; return acc; }, {});
let REGION_LABELS = labelMap();

export const getRegionLabel = (value) => REGION_LABELS[value] || 'City-Wide';

// Fire-and-forget hydration at module load.
axios.get(`${API_URL}/api/regions`)
  .then(res => {
    if (Array.isArray(res.data) && res.data.length) {
      REGIONS.length = 0;
      res.data.forEach(r => REGIONS.push(r));
      REGION_LABELS = labelMap();
    }
  })
  .catch(() => { /* keep fallback */ });
